export const FirstLine = ['1', '2', '3']
export const SecondLine = ['4', '5', '6']
export const ThirdLine = ['7', '8', '9']
export const Arm = { value: 'A', title: 'ARM' }
export const Zero = '0'
export const E = 'E'
